export default "__VITE_ASSET__de5b8f5d__"